export default {
	"owner" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": ["createdBy","createdDate","modifiedBy","modifiedDate"],
    	"hide": []
    },
	"corporate" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": ["createdBy","createdDate","modifiedBy","modifiedDate"],
    	"hide": []
    },
	"devadmin" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": [],
    	"hide": []
    },
	"sbsCtc" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": ["createdBy","createdDate","modifiedBy","modifiedDate"],
    	"hide": []
    },
	"anonymous" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": [],
    	"hide": []
    },
	"admin" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": ["createdBy","createdDate","modifiedBy","modifiedDate"],
    	"hide": []
    },
	"gbuFctOfficers" : 	{
    	"enableonlyfields": ["*"],
    	"disableonlyfields": ["createdBy","createdDate","modifiedBy","modifiedDate"],
    	"hide": []
    }}